import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../../common/theme/ISpcTheme';

export type IPriceValueClasses = 'boldPrice' | 'price' | 'priceContainer' | 'listText' | 'thinPrice';

const priceValueStyles = makeStyles<ISpcTheme, IPriceValueClasses>(
  theme => ({
    boldPrice: {
      fontWeight: 'bold',
      fontSize: theme.typography.fontMD,
      wordBreak: 'break-word',
    },
    price: {
      fontSize: theme.typography.fontMD,
    },
    priceContainer: {
      textAlign: 'end',
    },
    listText: {
      fontSize: theme.typography.fontMD,
    },
    thinPrice: {},
  }),
  { name: 'Customise_PriceValue' },
);

export default priceValueStyles;
